import React from 'react';
import { Button } from 'primereact/button';
import { FormField } from '../../FormField/FormField';
import { UserDisplay } from '../../UserDisplay/UserDisplay';
import { UsersSelect } from '../../UsersSelect/UsersSelect';
import { ReservationFormFieldProps } from '../types';

interface Props extends Pick<ReservationFormFieldProps, 'form' | 'setFormFields'> {
  isModifying: boolean;
}

/** An employee shown for information only. It does not change availability. */
export const InformativeEmployeeField = ({ form, setFormFields, isModifying }: Props) => {
  return (
    <FormField labelTitle='Empleado (informativo)' elementId='reservation-informative-employee' fullWidth>
      {isModifying ? (
        <div className='informative-employee-field'>
          <UsersSelect
            id='reservation-informative-employee'
            value={form?.informativeUser?.id}
            placeholder='Elige un empleado (opcional)'
            onChange={(informativeUser) => setFormFields({ informativeUser })}
            filterByBranchIds={form?.branch?.id ? [form?.branch?.id] : undefined}
            disabled={!form?.branch?.id}
          />
          {form?.informativeUser && (
            <Button
              type='button'
              link
              label='Quitar'
              className='clear-informative-employee'
              onClick={() => setFormFields({ informativeUser: undefined })}
            />
          )}
        </div>
      ) : form?.informativeUser ? (
        <UserDisplay
          name={form?.informativeUser?.name}
          surnames={form?.informativeUser?.surnames}
          avatarUrl={form?.informativeUser?.avatarUrl}
        />
      ) : (
        <p>-</p>
      )}
    </FormField>
  );
};
